import React, { type ReactElement } from 'react';

import {
  GismartSVG,
  Com24SVG,
  GruponSVG,
  WetterSVG,
  PayitSVG,
  BladestormSVG,
  AlinmaBankSVG,
  AvatradeSVG,
  GanSVG,
  Media24SVG,
  JuvoSVG,
  ArabClicksSVG,
  JustDiceSVG,
  IndiaTodaySVG,
} from '../../assets/images';
import { H4 } from '../../ui/typography';

import { RootLogoBox, RootLogos } from './CustomerLogos.styles';

export function CustomerLogos(): ReactElement {
  return (
    <RootLogoBox>
      <H4>Trusted globally across industries:</H4>
      <RootLogos>
        <GismartSVG />
        <Com24SVG />
        <GruponSVG />
        <WetterSVG />
        <PayitSVG />
        <BladestormSVG />
        <AlinmaBankSVG />
        <AvatradeSVG />
        <GanSVG />
        <Media24SVG />
        <JuvoSVG />
        <ArabClicksSVG />
        <JustDiceSVG />
        <IndiaTodaySVG />
      </RootLogos>
    </RootLogoBox>
  );
}
